import React from 'react';
import {injectIntl} from "react-intl";
import {Popover} from "antd";

class SAPopover extends React.Component {

  render() {
    const {intl: {formatMessage}, content, action, trigger, visible, onVisibleChange, placement} = this.props;

    return (
      <Popover title={formatMessage({id: `popup.${action}.confirmation`})}
               trigger={trigger}
               visible={visible}
               placement={placement}
               onVisibleChange={onVisibleChange}
               content={content}>
        {this.props.children}
      </Popover>
    )
  }
}

export default injectIntl(SAPopover);



// WEBPACK FOOTER //
// ./src/components/common/confirmation/SAPopover.js